<template>
  <div class="container-controlpanel">
    <!-- 一级菜单： -->
    <div class="item" v-for="(item, index) in items" :key="index">
      <a class="primaryList" :class="item.primaryActive" @click="Change(item.name)">
        <div class="content">
          <i :class="item.icon" class="primary-icon"></i>
          <h2>{{ item.title }}</h2>
          <i :class="item.iconMore" class="iconMore"></i>
        </div>
      </a>
      <!-- 二级菜单： -->
      <!-- <transition name="fade"> -->
      <div class="secondaryList" v-if="item.secondaryLists !== null" v-show="item.secondaryActive">
        <router-link v-for="(item, index) in item.secondaryLists" :key="index" :to="item.urlname" active-class="active">
          <div class="secondaryContent">
            <i :class="item.icon" class="secondary-icon"></i>
            <h2 class="secondaryTitle">{{ item.title }}</h2>
          </div>
        </router-link>
      </div>
      <!-- </transition> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ControlPanel",
};
</script>

<script setup>
import { reactive } from "vue";
// vue3中使用vue-router
import { useRouter } from "vue-router";
const router = useRouter();

const items = reactive([
  {
    // name必须与index.js中的name一致
    title: "返回首页",
    name: "home",
    icon: "iconfont icon-home",
    iconMore: " ",
    primaryActive: " ",
    secondaryActive: false,
    secondaryLists: [],
  },
  // {
  //   title: "我的工程",
  //   name: "myProject",
  //   icon: "iconfont icon-myproject",
  //   iconMore: " ",
  //   primaryActive: " ",
  //   secondaryActive: false,
  //   secondaryLists: [],
  // },
  {
    title: "建议与反馈",
    name: "feedBack",
    icon: "iconfont icon-woyaofankui",
    iconMore: " ",
    primaryActive: " ",
    secondaryActive: false,
    secondaryLists: [],
  },
  {
    title: "能源电力",
    name: "cleanEnergy",
    icon: "iconfont icon-cleanpower",
    iconMore: "iconfont icon-chevron_left",
    primaryActive: " ",
    secondaryActive: false,
    secondaryLists: [
      {
        title: "风机基础计算",
        name: "windBaseDesign",
        icon: "iconfont icon-item",
        urlname: "/cleanenergy/windbase_design",
      },
      {
        title: "风机基础制图",
        name: "windBase_draw",
        icon: "iconfont icon-item",
        urlname: "/cleanenergy/windbase_draw",
      },
      // {
      //   title: "光伏支架",
      //   name: "solarBracket",
      //   icon: "iconfont icon-item",
      //   urlname: "/cleanenergy/solarbracket",
      // },
      // {
      //   title: "箱逆变基础",
      //   name: "acDcBase",
      //   icon: "iconfont icon-item",
      //   urlname: "/cleanenergy/acdcbase",
      // },
    ],
  },
  {
    title: "智筑工具箱",
    name: "structuralToolbox",
    icon: "iconfont icon-gongju1",
    iconMore: " ",
    primaryActive: " ",
    secondaryActive: false,
    secondaryLists: [],
  },
]);

function Change(name) {
  items.forEach((item) => {
    if (item.secondaryLists.length > 0) {
      // if (item.name === name && item.secondaryActive === false) {
      //   item.secondaryActive = !item.secondaryActive;
      //   item.iconMore = "iconfont icon-chevron_down";
      // }
      if (item.name === name) {
        item.secondaryActive = !item.secondaryActive;
        if (item.secondaryActive === false) {
          item.iconMore = "iconfont icon-chevron_left";
        } else {
          item.iconMore = "iconfont icon-chevron_down";
        }
      }
      if (item.name !== name && item.secondaryActive === true) {
        item.secondaryActive = !item.secondaryActive;
        item.iconMore = "iconfont icon-chevron_left";
      }
    } else {
      if (item.name === name) {
        item.primaryActive = "active";
        router.push({ name: name });
      }
      if (item.name !== name) {
        item.primaryActive = " ";
      }
    }
  });
}
</script>

<style scoped>
/* 一二级a标签公共样式（含由router-link转化而来的a标签属性） */
a {
  cursor: pointer;
}

a:hover {
  background-color: #192124;
}

a:hover h2,
a:hover .iconfont {
  color: var(--fontActive-color);
}

/* 第一级a标签内的样式 */
.content {
  display: flex;
  align-items: center;
  padding: 15px 10px 15px 15px;
}

.content h2 {
  font-size: 15px;
  font-weight: bold;
  padding-left: 11px;
  padding-right: 60px;
  /* padding-bottom: 2px; */
  padding-top: 2px !important;
}

.primary-icon {
  font-size: 20px;
}

/* 第二级a标签内的样式 */
.secondaryList {
  background-color: var(--primary-panel-secondary-color);
}

.secondaryContent {
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 15px;
}

.secondaryContent h2 {
  font-size: 13px;
  font-weight: bold;
  padding-left: 12px;
  padding-right: 60px;
  padding-top: 1px;
}

.secondary-icon {
  font-size: 14px;
  padding: 0 2px 0 2px;
}

/* 点击后激活样式 */
.active {
  background-color: rgb(26, 34, 38);
}

.active h2,
.active .iconfont {
  color: var(--fontActive-color);
}

/* 手机屏幕样式 ***************************/
@media (orientation: portrait) and (max-width: 768px) {

  .primary-icon,
  iconMore,
  .secondary-icon {
    display: none;
  }

  .content,
  .secondaryContent {
    padding-left: 0;
    border-bottom: #818686 solid 1px;
  }

  .content h2 {
    font-size: 13px;
    text-align: center;
  }

  .secondaryContent h2 {
    font-size: 11px;
    text-align: center;

  }
}
</style>
